"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParseUtils = void 0;
var ParseUtils = /** @class */ (function () {
    function ParseUtils() {
    }
    ParseUtils.itemIsType = function (o, expectedType) {
        return ({}).toString.call(o).match(/\s([a-zA-Z]+)/)[1].toLowerCase() == expectedType;
    };
    ParseUtils.getObjectValue = function (o, key, expectedType, allowNull) {
        if (this.itemIsType(o[key], expectedType)) {
            return o[key];
        }
        else if (allowNull) {
            return null;
        }
        else {
            throw TypeError("key '" + key + "' is (" + o[key] + "): " + typeof o[key] + ", expected " + expectedType);
        }
    };
    ParseUtils.parseSuccess = function (value) {
        return { success: true, value: value };
    };
    ParseUtils.parseFailure = function (justification) {
        return { success: false, justification: justification };
    };
    ParseUtils.getString = function (o, key) {
        return this.getObjectValue(o, key, 'string', false);
    };
    ParseUtils.getStringOrNull = function (o, key) {
        return this.getObjectValue(o, key, 'string', true);
    };
    ParseUtils.getNumber = function (o, key) {
        return this.getObjectValue(o, key, 'number', false);
    };
    ParseUtils.getNumberOrNull = function (o, key) {
        return this.getObjectValue(o, key, 'number', true);
    };
    ParseUtils.getUNIXTimestampDate = function (o, key) {
        return new Date(this.getObjectValue(o, key, 'number', false) * 1000);
    };
    ParseUtils.getUNIXTimestampDateOrNull = function (o, key) {
        var seconds = this.getObjectValue(o, key, 'number', true);
        if (seconds != null) {
            return new Date(seconds * 1000);
        }
        else {
            return null;
        }
    };
    ParseUtils.getISODate = function (o, key) {
        var date = new Date(this.getObjectValue(o, key, 'string', false));
        if (isNaN(date.getTime())) {
            throw TypeError("key '" + key + "' is (" + o[key] + "): " + typeof o[key] + ", expected ISODate");
        }
        else {
            return date;
        }
    };
    ParseUtils.getISODateOrNull = function (o, key) {
        var dateString = this.getObjectValue(o, key, 'string', true);
        if (dateString != null) {
            var date = new Date(dateString);
            if (isNaN(date.getTime())) {
                throw TypeError("key '" + key + "' is (" + o[key] + "): " + typeof o[key] + ", expected ISODate");
            }
            else {
                return date;
            }
        }
        else {
            return null;
        }
    };
    ParseUtils.getBoolean = function (o, key) {
        return this.getObjectValue(o, key, 'boolean', false);
    };
    ParseUtils.getBooleanOrNull = function (o, key) {
        return this.getObjectValue(o, key, 'boolean', true);
    };
    ParseUtils.getArray = function (o, key) {
        return this.getObjectValue(o, key, 'array', false);
    };
    ParseUtils.getArrayOrNull = function (o, key) {
        return this.getObjectValue(o, key, 'array', true);
    };
    ParseUtils.getSubobject = function (o, key, parseFunction) {
        var result = parseFunction(o[key]);
        if (result.success) {
            return result.value;
        }
        else {
            throw TypeError("Invalid subobject at key '" + key + "': " + result.justification);
        }
    };
    ParseUtils.getSubobjectOrNull = function (o, key, parseFunction) {
        var result = parseFunction(o[key]);
        return result.success ? result.value : null;
    };
    ParseUtils.getEnum = function (o, key, e, defaultValue) {
        var result = e[this.getString(o, key)];
        if (result != undefined) {
            return result;
        }
        else if (defaultValue != undefined) {
            return defaultValue;
        }
        else {
            throw TypeError("Invalid enum at key '" + key + "'");
        }
    };
    ParseUtils.getEnumOrNull = function (o, key, e) {
        var enumString = this.getStringOrNull(o, key);
        if (enumString != null) {
            return e[enumString];
        }
        else {
            return null;
        }
    };
    ParseUtils.getArrayOfSubobjects = function (o, key, parseFunction, failBehavior) {
        return (this.getArray(o, key))
            .map(function (elem) {
            var result = parseFunction(elem);
            if (result.success) {
                return result.value;
            }
            else {
                if (failBehavior == 'throw') {
                    throw TypeError("Invalid subobject: " + result.justification);
                }
                else {
                    if (failBehavior == 'warn') {
                        ParseUtils.onWarn("Ignoring invalid subobject: " + result.justification);
                    }
                    return null;
                }
            }
        })
            .filter(Boolean);
    };
    ParseUtils.getArrayOfSubobjectsOrNull = function (o, key, parseFunction, failBehavior) {
        if (this.getArrayOrNull(o, key) == null) {
            return null;
        }
        else {
            return this.getArrayOfSubobjects(o, key, parseFunction, failBehavior);
        }
    };
    ParseUtils.onWarn = function (m) { return console.warn(m); };
    return ParseUtils;
}());
exports.ParseUtils = ParseUtils;
//# sourceMappingURL=cerealParse.js.map